/**
 * The profile API surface: the consumer row and the identity record.
 */

import CLIENT from "../../lib/api/client";
import ENDPOINTS from "../../lib/api/endpoints";

const CONSUMER_SERVICES = {
  /** The consumer row — the source of profile truth. */
  fetchSelf: () => CLIENT.get(ENDPOINTS.CONSUMER.self),

  /**
   * FULL-REPLACE upsert, and the only call that creates the consumer row.
   * Always build the body with `toSavePayload` over a warm read.
   */
  save: (payload) => CLIENT.post(ENDPOINTS.CONSUMER.save, payload),

  /** Read-only. PATCH/PUT/POST against this path answer 405. */
  fetchIdentity: () => CLIENT.get(ENDPOINTS.AUTH.userProfile),

  /** Writes the identity record: { firstName, lastName, profileImage }. */
  patchIdentity: (payload) =>
    CLIENT.patch(ENDPOINTS.AUTH.updateUserProfile, payload),

  preferences: () => CLIENT.get(ENDPOINTS.CONSUMER.preferences),
};

export default CONSUMER_SERVICES;
